module.exports = __webpack_public_path__ + "static/media/arrow.41a1ea2b.svg";